/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import Name from './Name/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Content/Leads/Similar/Info/Details"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Details.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Name
  viewPath={`${viewPath}/Name`}
/>
</div>
{children}
</React.Fragment>)
}